import moment from 'moment';

export default function formatDateByFormat(date, format){
    return moment(date).isValid() ? moment(date).format(format) : '-';
}